import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
    import { TaskTemplate } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import AddButton from '@/components/AddButton.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import TaskTemplateForm from './TaskTemplateForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditTaskTemplate',
  props: {
    taskTemplate: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const taskTemplateForm = ref<InstanceType<typeof TaskTemplateForm>>();

    const props = __props;

    const form = useForm({
        name: props.taskTemplate.name,
        description: props.taskTemplate.description,
        tasks: props.taskTemplate.tasks.map((task) => ({
            title: task.title,
            description: task.description,
            weekdays: task.weekdays ? task.weekdays.split(',').map((day) => day.trim()) : [],
            status: task.status,
            responsible_id: task.responsible_id,
            send_notification: task.send_notification,
            notification_recurring_week: task.notification_recurring_week,
            notification_recurring_even_week: task.notification_recurring_even_week,
            notification_recurring_start_of_month: task.notification_recurring_start_of_month,
        })),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.task-templates.update', _ctx.taskTemplate.id),
    method: "patch",
    "query-key": [_unref(QueryKey).TASK_TEMPLATES],
    title: "task-templates.edit_txt",
    "modal-size": "sm:max-w-3xl"
  }, {
    footerActions: _withCtx(() => [
      _createVNode(AddButton, {
        class: "mr-auto",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (taskTemplateForm.value?.addTask()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('task-templates.add_task')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(TaskTemplateForm, {
        ref_key: "taskTemplateForm",
        ref: taskTemplateForm,
        form: _unref(form)
      }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})